export enum LaptopTransportType {
    Consultant = 1,
    Loggi = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/LaptopTransportType.ts